import { createStyles, rem } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    button: {
        width: "2.5rem",
        minWidth: "2.5rem",
        padding: "0px",
        backgroundColor: theme.colors.violet[7],
        border: "none",
        borderRadius: "2rem",
        transition: "none",

        "&:hover": {
            border: "none",

            [theme.fn.largerThan("xs")]: {
                backgroundColor: `${theme.colors.violet[8]} !important`, // because hover state sticks
            },
        },
        "&:focus": {
            boxShadow: "none",
            border: "none",
            [theme.fn.largerThan("xs")]: {
                backgroundColor: `${theme.colors.violet[3]}`,
            },
        },
        "&:active": {
            transform: "none",
        },
    },

    popdownIsOpen: {
        backgroundColor: "#fff",

        "&:hover": {
            border: "none",

            [theme.fn.largerThan("xs")]: {
                backgroundColor: `${theme.colors.violet[1]} !important`, // because hover state sticks
            },
        },
    },

    isOpened: {
        "&:hover": {
            border: "none",

            [theme.fn.largerThan("xs")]: {
                backgroundColor: `${theme.colors.violet[8]} !important`, // because hover state sticks
            },
        },
    },

    active: {
        boxShadow: "none",
        border: "none",
        backgroundColor: `${theme.colors.violet[9]} !important`,
    },
}))
